import { observer } from 'mobx-react';
import * as React from 'react';
import { L, T } from '../../../../../../../Translations';
import { ProductLicenseResource } from '../../../../../Types';
import { when } from '@execonline-inc/maybe-adapter';
import { emptyFragment } from '../../../../../../../EmptyFragment';

interface Props {
  activeProductLicense: ProductLicenseResource;
}

const LicenseStatus: React.FC<Props> = ({ activeProductLicense }) => {
  const { licenseQuantity, daysUntilRenewal, activationsRemaining } = activeProductLicense.payload;

  return (
    <div className="mt-1 mb-2 text-sm flex justify-around gap-10">
      {when(activeProductLicense.payload.displayActivationsRemaining, {})
        .map(() => (
          <div className="grow">
            <T
              kind="{{count}} License Available"
              count={activationsRemaining.getOrElseValue(licenseQuantity)}
            />
          </div>
        ))
        .getOrElse(emptyFragment)}
      <div className="grow">
        <T
          kind="Active until <date/>"
          date={
            <L localizeable={activeProductLicense.payload.endOn} format={'long-month-day-year'} />
          }
        />
      </div>
      {when(activeProductLicense.payload.displayRenewalNotice, {})
        .map(() => (
          <div className="text-[#991B1B] grow">
            <T kind="{{count}} day until renewal" count={daysUntilRenewal} />
          </div>
        ))
        .getOrElse(emptyFragment)}
    </div>
  );
};

export default observer(LicenseStatus);
